export const REDUX_SET = '/redux/container/VehicleReadyFlowContainer/set';
export const REDUX_RESET = '/redux/container/VehicleReadyFlowContainer/reset';
